__turbopack_context__.v({
  "root": "gpT9ja_root" + " " + __turbopack_context__.i(931616)["ctaStyle"],
});
